import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewUserCounter } from 'app/shared/models/class/counter/counter';
import { CustomerDetails, SocialUserSignUp, UserSignUp } from 'app/shared/models/class/user/user';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getUserDetails(userKey: number): Observable<CustomerDetails> {
    return this.http.get<CustomerDetails>(`${environment.apiUrl}/users/${userKey}`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  signup(newUser: SocialUserSignUp): Observable<UserSignUp> {
    return this.http.post<UserSignUp>(`${environment.apiUrl}/users`, newUser);
  }

  signByMail(newUser): Observable<UserSignUp> {
    return this.http.post<UserSignUp>(`${environment.apiUrl}/users/UserByMail`, newUser);
  }

  changePassword() {
    return this.http.post(`${environment.apiUrl}/users/password`, null);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateUser(user: NewUserCounter) {
    return this.http.put(`${environment.apiUrl}/users/updateUser`, user);
  }

}
